import BN from 'bignumber.js'

export const newBN = BN.clone({ EXPONENTIAL_AT: 500 }) // 数字超过500位变成科学计数法

export default newBN
